export function render({ node, api }) {
  const root = document.createElement('div');

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = node.props?.title || 'Option Picker';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  const label = document.createElement('label');
  label.textContent = node.props?.label || 'Select one';

  const select = document.createElement('select');
  const options = Array.isArray(node.props?.options) && node.props.options.length
    ? node.props.options
    : ['Alpha', 'Beta', 'Gamma'];

  options.forEach((opt) => {
    const option = document.createElement('option');
    option.value = String(opt);
    option.textContent = String(opt);
    select.appendChild(option);
  });

  const current = node.data?.choice ?? options[0];
  select.value = current;

  const onChange = () => {
    api.setData({ choice: select.value });
    api.emit('node:input', { id: node.id, field: 'choice', value: select.value });
  };

  select.addEventListener('change', onChange);

  body.append(label, select);
  root.append(header, body);

  return {
    el: root,
    update: (next) => {
      const nextOptions = Array.isArray(next.props?.options) && next.props.options.length
        ? next.props.options
        : options;
      if (nextOptions.length !== select.options.length) {
        select.innerHTML = '';
        nextOptions.forEach((opt) => {
          const option = document.createElement('option');
          option.value = String(opt);
          option.textContent = String(opt);
          select.appendChild(option);
        });
      }
      const nextValue = next.data?.choice ?? nextOptions[0];
      if (select.value !== nextValue) select.value = nextValue;
      title.textContent = next.props?.title || 'Option Picker';
      label.textContent = next.props?.label || 'Select one';
    },
    cleanup: () => {
      select.removeEventListener('change', onChange);
    }
  };
}
